import styled from 'styled-components/macro';
import { Link } from '@yme/components/Link';
import { ButtonLinkWrapper } from '@yme/molecules/buttons';
import { hoverStyles } from '@yme/molecules/buttons/styled';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { escapeImageUrl } from '@yme/utils/common';
import { AspectRatio } from '@yme/utils/constants';
import { NEWS_CARD_OVERLAY } from './constants';
export const NewsCardStyled = styled(FlexWrapper) `
  background: ${NEWS_CARD_OVERLAY},
    url(${({ backgroundImage = '' }) => escapeImageUrl(backgroundImage)});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  aspect-ratio: ${({ aspectRatioValue = AspectRatio.Square }) => aspectRatioValue};

  width: 100%;
  height: 100%;

  ${({ isCardAsLink }) => isCardAsLink && hoverStyles};
`;
export const LinkStyled = styled(Link) `
  text-decoration: none;
`;
export const ContentAreaStyled = styled.div `
  width: 100%;
`;
export const ElementLinkWrapperStyled = styled(ButtonLinkWrapper) `
  width: 100%;
  height: 100%;
`;
